export const PALETTES = {
  lavender: { name: "Dreamy Lavender", bg: "#F3E8FF", darkBg: "#2E1065", border: "#C084FC", text: "#581C87", darkText: "#F3E8FF" },
  mint: { name: "Fresh Mint", bg: "#DCFCE7", darkBg: "#052E16", border: "#4ADE80", text: "#14532D", darkText: "#DCFCE7" },
  butter: { name: "Butter Yellow", bg: "#FEF9C3", darkBg: "#422006", border: "#FACC15", text: "#713F12", darkText: "#FEF08A" },
  sky: { name: "Sky Breeze", bg: "#E0F2FE", darkBg: "#0C4A6E", border: "#38BDF8", text: "#0C4A6E", darkText: "#E0F2FE" },
  peach: { name: "Peach Fizz", bg: "#FFEDD5", darkBg: "#431407", border: "#FB923C", text: "#7C2D12", darkText: "#FFEDD5" },
  cyber_pink: { name: "Cyber Pink", bg: "#FCE7F3", darkBg: "#500724", border: "#F472B6", text: "#831843", darkText: "#FCE7F3" },
  neo_slate: { name: "Neo Slate", bg: "#F1F5F9", darkBg: "#1E293B", border: "#94A3B8", text: "#0F172A", darkText: "#F1F5F9" },
};

export function paletteStyle(colorId, dark) {
  const p = PALETTES[colorId] || PALETTES.neo_slate;
  return {
    background: dark ? p.darkBg : p.bg,
    borderColor: p.border,
    color: dark ? p.darkText : p.text,
  };
}

export const ROLE_COLORS = {
  admin: "bg-pink-500/15 text-pink-600 border-pink-400",
  manager: "bg-violet-500/15 text-violet-600 border-violet-400",
  executive: "bg-sky-500/15 text-sky-600 border-sky-400",
};
